<script>
import { authComputed, authMethods } from '@state/helpers'
import { chatComputed } from '@state/chatHelper'
import SafehavenAppBar from '@/src/components/layout/safehaven-app-bar.vue'
import SafehavenNavDrawer from '@/src/components/layout/safehaven-nav-drawer.vue'
import ScrollToTopButton from '@/src/components/scroll-to-top-button.vue'
import CalendarDrawer from '@/src/components/safehaven-calendar/safehaven-calendar-drawer.vue'
import MinimizeComponent from '@/src/components/minimize-component.vue'
import Footer from '@/src/components/footer.vue'

export default {
  components: {
    SafehavenAppBar,
    ScrollToTopButton,
    SafehavenNavDrawer,
    CalendarDrawer,
    MinimizeComponent,
    Footer,
  },
  computed: {
    ...authComputed,
    ...chatComputed,
  },
  mounted() {},
  methods: {
    ...authMethods,
    toggleBot() {
      window.KoreSDK.show(window.KoreSDK.chatConfig)
      if (document.getElementsByClassName('kore-chat-window')) {
        const chatWindowEl = document.getElementsByClassName(
          'kore-chat-window'
        )[0]

        document.getElementsByClassName(
          'kore-chat-header'
        )[0].style.backgroundColor = '#082787'

        chatWindowEl.style.height = '40%'
        if (chatWindowEl.style.display === 'none') {
          chatWindowEl.style.display = ''
        }
      }
      document.getElementsByClassName('minimized')[0].click()
      document
        .getElementsByClassName('close-btn')[0]
        .addEventListener('click', this.closeBot)
    },
    closeBot() {
      document.getElementsByClassName('kore-chat-window')[0].style.display =
        'none'
    },
  },
}
</script>

<template>
  <div :class="$style.mainwrapp">
    <SafehavenAppBar></SafehavenAppBar>
    <SafehavenNavDrawer></SafehavenNavDrawer>
    <CalendarDrawer width="320" />
    <MinimizeComponent
      :v-if="getChatDialogStatus && getChatDialogStatus.dialog"
    ></MinimizeComponent>
    <CalendarDrawer width="320" />
    <v-main>
      <v-container
        id="main_page"
        :class="$style.mainContainer"
        class="fill-height pa-0"
        fluid
      >
        <!-- main slot -->
        <slot />
        <!-- scroll to top button -->
        <ScrollToTopButton></ScrollToTopButton>
      </v-container>
    </v-main>
    <Footer></Footer>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.mainContainer {
  align-items: flex-start !important;
  margin-bottom: 50px;
  background: linear-gradient(
    195.23deg,
    #d5f9ff 2.93%,
    #eefbff 33.41%
  ) !important;
  border-color: #f2f9ff !important;
}
.mainwrapp {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  overflow: hidden;
}
.chatbotWrapper {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 100px;
  cursor: pointer;
  background-color: #89b85e;
}
.rotate {
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: white;
  text-align: left;
  letter-spacing: 0;

  /* Legacy vendor prefixes that you probably don't need... */

  /* Safari */
  -webkit-transform: rotate(-90deg);

  /* Firefox */
  -moz-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
</style>
